import React from 'react';
import { Search, CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface MobileStickyBarProps {
  hasSearched: boolean;
  resultCount: number;
  importedCount: number;
  onScrollToSearch: () => void;
  onViewImported: () => void;
}

const MobileStickyBar: React.FC<MobileStickyBarProps> = ({
  hasSearched,
  resultCount,
  importedCount,
  onScrollToSearch,
  onViewImported
}) => {
  const isMobile = useIsMobile();
  
  if (!isMobile || !hasSearched) return null;
  
  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 border-t bg-background/95 backdrop-blur-sm shadow-lg">
      <div className="p-3 flex items-center justify-between max-w-screen-sm mx-auto">
        <div className="flex items-center gap-2 px-3">
          <span className="text-sm font-medium">{resultCount} results</span>
          {importedCount > 0 && (
            <>
              <span className="text-muted-foreground">•</span>
              <span className="text-sm text-green-600 font-medium flex items-center gap-1">
                <CheckCircle className="h-3 w-3" />
                {importedCount}
              </span>
            </>
          )}
        </div>
        
        <div className="flex gap-1">
          {importedCount > 0 && (
            <Button 
              size="sm" 
              variant="ghost"
              onClick={onViewImported}
              className="h-8"
            >
              View
            </Button>
          )}
          <Button 
            size="sm" 
            variant="outline"
            onClick={onScrollToSearch}
            className="h-8"
          >
            <Search className="h-3 w-3 mr-1" />
            Edit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileStickyBar;
